'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useSecureAuthContext } from '@/core/auth/services';

// This component handles the root route ('/')
export default function RootPage() {
  const router = useRouter();
  const { isAuthenticated, isLoading } = useSecureAuthContext();

  useEffect(() => {
    // Don't redirect while checking auth status
    if (isLoading) return;

    // Authenticated users go to dashboard
    if (isAuthenticated) {
      router.replace('/dashboard');
    } else {
      // Non-authenticated users go to the marketing home page
      router.replace('/home');
    }
  }, [router, isAuthenticated, isLoading]);

  // Show nothing while redirecting
  return null;
}